// @flow
import React from 'react'
import { css } from 'aphrodite/no-important'
import styles from './style'

export default function ForgotPassword(): React$Node<'div'> {
  return <div className={css(styles.loginPage)}>Passwort vergessen</div>
}
